var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jade-status-tracker", class: _vm.computedClassList },
    [
      _c(
        "div",
        { staticClass: "jade-status-tracker__step-container" },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "jade-status-tracker__step",
              class: `is-${item.status}`,
            },
            [
              _c(
                "div",
                { staticClass: "jade-status-tracker__marker-container" },
                [
                  _c(
                    "div",
                    { staticClass: "jade-status-tracker__marker" },
                    [
                      _c("jade-status-tracker-icon", {
                        attrs: { use: item.status },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "jade-status-tracker__path-line" }),
                ]
              ),
              _c("jade-status-tracker-content", {
                attrs: {
                  description: item.description,
                  link: item?.link,
                  label: item.label,
                  status: item.status,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }